import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import InfoPage from "@/pages/InfoPage";
import Guides from "@/pages/Guides";
import Article from "@/pages/Article";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import { AccessibilityWidget } from "@/components/AccessibilityWidget";
import { CATEGORIES } from "@/data/categories";
import { INFO_PAGES } from "@/data/infoPages";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <HelmetProvider>
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <BrowserRouter>
            <ScrollToTop />
            <div className="App min-h-screen bg-white">
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                {CATEGORIES.map((c) => (
                  <Route key={c.slug} path={`/${c.slug}`} element={<CategoryPage category={c} />} />
                ))}
                {Object.entries(INFO_PAGES).map(([slug, page]) => (
                  <Route key={slug} path={`/${slug}`} element={<InfoPage page={page} slug={slug} />} />
                ))}
                <Route path="/guides" element={<Guides />} />
                <Route path="/guides/:slug" element={<Article />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
              <Footer />
              <AccessibilityWidget />
            </div>
            <Toaster position="top-center" richColors />
          </BrowserRouter>
      </ReactLenis>
    </HelmetProvider>
  );
}

export default App;
